<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备站点</span>
      </div>
    </div>
     <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>设备站点代表设备所在地方的简称，如：重庆大学图书馆、西南医院第3住院部
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="page.value" placeholder="根据条件搜索" @on-enter="getData(1)">
          <Select v-model="page.cond" slot="prepend" style="width: 100px">
            <Option value="site.id">站点编号</Option>
            <Option value="site.name">站点名称</Option>
            <!-- <Option value="user_agent.id">所属编号</Option> -->
            <Option value="user_agent.name" v-if="!user.tp">所属</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <!-- <Select v-model="page.is_del" style="margin-right: 5px">
          <Option :value="0">站点列表</Option>
          <Option :value="1">回收站</Option>
        </Select> -->
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button type="primary" @click="preCreate">新增站点</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading" @on-sort-change="tableSort"/>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" :current="page.p + 1" show-elevator show-sizer show-total/>
    </div>

    <Modal v-model="visible" :width="480" :title="current.id?'修改站点':'新增站点'">
      <div class="tips" style="margin-bottom: 20px;">站点名称修改后，以前产生的订单记录中的站点名称也会同时被修改，请谨慎操作</div>
      <Form :label-width="100" >
        <FormItem label="站点名称:">
          <Input v-model="current.name" style="width:230px" placeholder="输入站点名称"/>
        </FormItem>
        <FormItem label="站点所属:" v-if="siteAccess()">
          <Select v-model="current.agent_id" style="width:230px" placeholder="默认自营">
            <Option :value="0">自营</Option>
            <Option v-for="(item,index) in agent" :value="item.id" :key="index">{{item.agent_name}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" v-preventReClick :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasOneOf } from '@/libs/tools'
import excel from '@/libs/excel'
export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10,
        cond: 'site.id',
        value: '',
        is_del: 0,
        key: 'id',
        order: 'desc'
      },
      data: [],
      total: 0,
      tableLoading: false,
      columns: [
        { title: '编号', key: 'id', sortable: 'custom', _sortKey: 'site.id',width:100, },
        { title: '站点名称', key: 'name', sortable: 'custom', _sortKey: 'site.name'},
        { title: '所属', key: 'agent_name', sortable: 'custom', _sortKey: 'user_agent.name'},
        { title: '操作',
          width:200 ,
          key: 'operator',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', {
                props: { size: 'small', type: data.row.is_del ? 'success' : 'error' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: `是否${data.row.is_del ? '恢复' : '删除'}`,
                      content: `是否${data.row.is_del ? '恢复' : '删除'}该站点`,
                      loading: this.confirmLoading,
                      onOk: () => {
                        this.confirmLoading = true
                        this.DelSite({id: data.row.id,is_del: data.row.is_del ? 0 : 1}).then(res=>{
                          if(res.status){
                            this.$Message.success("操作成功")
                            this.getData();
                          }else{
                            this.$Message.error("无法删除已使用站点")
                          }
                          this.confirmLoading = false;
                          // this.$Modal.remove()
                        })
                      }
                    })
                  }
                }
              }, data.row.is_del ? '恢复' : '删除'),
              h('Button', {
                props: { size: 'small', type: 'warning' },
                on: {
                  click: () => {
                    let temp = JSON.parse(JSON.stringify(data.row))
                    this.preCreate(temp)
                  }
                }
              }, '修改')
            ])
          } }
      ],
      visible: false,
      current: {},
      agent: [], // 代理商
      loading: false,
      confirmLoading: false
    }
  },
  methods: {
    exportData (is_all) {
      let params = {
        title: ['编号', '站点名称', '所属'],
        key: ['id', 'name', 'agent_name'],
        autoWidth: true,
        filename: '站点列表'
      }
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page))
        page.l = this.total
        page.p = 0;
        this.getSite(page).then(res => {
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.data
        excel.export_array_to_excel(params)
      }
    },
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    reset () {
      this.page.cond = 'site.id'
      this.page.value = ''
      this.getData()
    },
    // 保存站点(新增 修改)
    save () {
      if (!this.current.name) {
        this.$Message.error('未填写站点名称')
        return
      }
      this.loading = true
      if (!this.current.agent_id) {
        delete this.current.agent_id
      }
      let data = JSON.parse(JSON.stringify(this.current))
      delete data.agent_name
      delete data._index
      delete data._rowKey
      delete data.isTrusted
      console.log('保存站点')
      this.saveSite(data).then(res => {
        this.loading = false
        if(res){
          this.getData()
          this.visible = false
        }else{
          this.$Message.error("站点名称重复,操作失败")
        }

      })
    },
    // 新增站点前 数据准备
    preCreate (data) {
      this.current = data || {}
      if (!this.user.tp && !this.agent.length) {
        this.visible = true
        this.getAgentList({ is_del: 0, l: 1000 }).then(res => {
          this.agent = res.data
        })
      } else {
        this.visible = true
      }
    },
    // 站点选择代理商权限控制
    siteAccess () {
      return hasOneOf(['0'], this.access)
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData (filter) {
      if(filter){
        this.page.p = 0;
      }
      this.tableLoading = true
      this.getSite(this.page).then(res => {
        this.total = res.total
        this.data = res.data
        this.tableLoading = false
      })
    },
    ...mapActions(['getSite', 'getAgentList', 'saveSite', 'DelSite'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  }),
  watch: {
    'page.is_del' (n, o) {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
